import AsyncSelect from "react-select/async";
import { DateInput } from "react-hichestan-datetimepicker";
import { useContext, useEffect, useState } from "react";
import { Tab, Table, Tabs } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import TooltipTitle from "./../../../utils/TooltipTitle/TooltipTitle";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import CustomDateTimePicker from "./../../../utils/CustomDateTimePicker/CustomDateTimePicker";
import ItemInfo from "./../../../utils/ItemInfo/ItemInfo";
import Currency, { ConvertCurrency } from "../../../utils/Currency/Currency";
import Animations from "../../../utils/Animations";
import { personnelAdminContext } from "../../../context/Admin/PersonnelAdminContext/PersonnelAdminContext";
import {
  activityTypeItems,
  convertDate,
  convertPercentNumber,
  dialogContainerStyle,
  expertTypeItems,
  numberSeparate,
  personnelTypeButton,
} from "../../../utils";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

const PersonnelAdmin = () => {
  const appConfigs = useSelector((state) => state.appConfigs);
  const isLoader = useSelector((state) => state.isLoader);
  const permission = useSelector((state) => state.permission);

  const {
    categories,
    personnels,
    services,
    setServices,
    personnel,
    search,
    setSearch,
    type,
    setType,
    totalCount,
    pageNumber,
    setPageNumber,
    limit,
    setLimit,
    isShowModal,
    violations,
    failureRequests,
    invoices,
    paymentTransactions,
    detailsTotalCount,
    detailsPageNumber,
    setDetailsPageNumber,
    detailsLimit,
    setDetailsLimit,
    // Personnel Create And Update Item
    id,
    first_name,
    setFirst_name,
    last_name,
    setLast_name,
    username,
    setUsername,
    mobile,
    setMobile,
    about_me,
    setAbout_me,
    birth_date,
    setBirth_date,
    father_name,
    setFather_name,
    phone_numbers,
    setPhone_numbers,
    business_address,
    setBusiness_address,
    balance,
    balanceFilter,
    setBalanceFilter,
    shaba,
    setShaba,
    cooperation_percentage,
    setCooperation_percentage,
    initial_invest,
    setInitial_invest,
    description,
    setDescription,
    vacation,
    setVacation,
    to_date,
    setTo_date,
    from_date,
    setFrom_date,
    status,
    setStatus,
    isSpecial,
    setIsSpecial,
    isActive,
    setIsActive,
    is_active,
    setIs_active,
    is_special,
    setIs_special,
    expertiseSearch,
    setExpertiseSearch,
    from_registry_date,
    setFrom_registry_date,
    to_registry_date,
    setTo_registry_date,
    from_quit_date,
    setFrom_quit_date,
    to_quit_date,
    setTo_quit_date,
    activeTab,
    setActiveTab,
    sort_by,
    setSort_by,
    isShowDetailsModal,
    isShowExpertiseModal,
    isSelectExpertise,
    handleCloseDetailsModal,
    handleShowModal,
    handleCloseModal,
    handleGetCategories,
    handleGetViolations,
    handleGetFailureRequests,
    handleGetInvoices,
    handleGetPaymentTransactions,
    handleGetPersonnels,
    handleGetPersonnel,
    expert_type,
    setExpert_type,
    activity_type,
    setActivity_type,
    working_by_foolad,
    setWorking_by_foolad,
    isShowAdvancedSearch,
    setIsShowAdvancedSearch,
    handleDeletePersonnel,
    handleCreatePersonnel,
    handleShowDetailsModal,
    handleShowExpertiseModal,
    handleCloseExpertiseModal,
    handleUpdatePersonnelExpertise,
    handleSearchServices,
    handleGetServices,
    handleEditPersonnel,
    handleDateRange,
    handleUploadDocument,
    handleDeleteDocument,
    handleGetDocument,
  } = useContext(personnelAdminContext);

  useEffect(() => {
    handleGetCategories();
  }, []);

  useEffect(() => {
    handleGetPersonnels();
  }, [pageNumber, limit, isSpecial, type, sort_by]);

  useEffect(() => {
    if (isShowDetailsModal || isShowModal) {
      switch (activeTab) {
        case "2":
          handleGetViolations();
          break;
        case "3":
          handleGetFailureRequests();
          break;
        case "4":
          handleGetInvoices();
          break;
        case "5":
          handleGetPaymentTransactions();
          break;

        default:
          break;
      }
    }
  }, [
    isShowDetailsModal,
    isShowModal,
    detailsLimit,
    detailsPageNumber,
    activeTab,
    status,
  ]);
  useEffect(() => {
    setDetailsPageNumber(1);
  }, [activeTab]);

  const sortByOptions = [
    {
      label: "تاریخ ایجاد",
      options: [
        { title: "نزولی", value: "-created" },
        { title: "صعودی", value: "created" },
      ],
    },
    {
      label: "اعتبارحساب",
      options: [
        { title: "نزولی", value: "-balance" },
        { title: "صعودی", value: "balance" },
      ],
    },
    {
      label: "رتبه",
      options: [
        { title: "نزولی", value: "-ratings" },
        { title: "صعودی", value: "ratings" },
      ],
    },
    {
      label: "تعداد امتیاز",
      options: [
        { title: "نزولی", value: "-ratings_count" },
        { title: "صعودی", value: "ratings_count" },
      ],
    },
    {
      label: "نام",
      options: [
        { title: "نزولی", value: "-first_name" },
        { title: "صعودی", value: "first_name" },
      ],
    },
    {
      label: "نام خانوادگی",
      options: [
        { title: "نزولی", value: "-last_name" },
        { title: "صعودی", value: "last_name" },
      ],
    },
    {
      label: "موبایل",
      options: [
        { title: "نزولی", value: "-mobile" },
        { title: "صعودی", value: "mobile" },
      ],
    },
  ];

  const personnelForm = () => (
    <form
      onSubmit={id ? handleEditPersonnel : handleCreatePersonnel}
      autoComplete="off"
    >
      <div className="row">
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label htmlFor="first_name">نام</label>
          <input
            type="text"
            id="first_name"
            name="first_name"
            className="form-control"
            value={first_name}
            onChange={(e) => setFirst_name(e.target.value)}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label htmlFor="last_name">نام خانوادگی</label>
          <input
            type="text"
            id="last_name"
            name="last_name"
            className="form-control"
            value={last_name}
            onChange={(e) => setLast_name(e.target.value)}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label htmlFor="last_name">نام پدر</label>
          <input
            type="text"
            id="father_name"
            name="father_name"
            className="form-control"
            value={father_name}
            onChange={(e) => setFather_name(e.target.value)}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label htmlFor="username">کد پرسنلی</label>
          <input
            type="text"
            id="username"
            name="username"
            className="form-control"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label htmlFor="mobile">موبایل</label>
          <input
            type="text"
            id="mobile"
            name="mobile"
            className="form-control"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label htmlFor="shaba">شماره شبا</label>
          <input
            type="text"
            id="shaba"
            name="shaba"
            className="form-control"
            value={shaba}
            onChange={(e) => setShaba(e.target.value)}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label htmlFor="balance">بدهکاری کل</label>
          <input
            type="text"
            id="balance"
            name="balance"
            className="form-control"
            value={`${numberSeparate(balance)} ریال`}
            // onChange={(e) => setBalance(e.target.value)}
            readOnly
            disabled
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label htmlFor="cooperation_percentage">درصد همکاری</label>
          <input
            type="text"
            id="cooperation_percentage"
            name="cooperation_percentage"
            className="form-control"
            value={cooperation_percentage}
            onChange={(e) => setCooperation_percentage(e.target.value)}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label htmlFor="initial_invest">بلوکه</label>
          <input
            type="text"
            id="initial_invest"
            name="initial_invest"
            className="form-control"
            value={initial_invest}
            onChange={(e) => setInitial_invest(e.target.value)}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label htmlFor="birth_date">تاریخ تولد</label>
          <CustomDateTimePicker
            placeholder="تاریخ تولد را انتخاب کنید"
            onChange={(e) => setBirth_date(e)}
            initValue={isEmpty(birth_date) ? null : birth_date}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label htmlFor="expert_type">نوع متخصص</label>
          <select
            className="form-control"
            name="expert_type"
            onChange={(e) =>
              setExpert_type(e.target.value ? Number(e.target.value) : null)
            }
          >
            <option selected value="" disabled hidden>
              لطفا نوع متخصص را انتخاب کنید
            </option>
            {expertTypeItems?.map((_value, index) => (
              <option
                key={index + 1}
                selected={index + 1 === expert_type}
                value={index + 1}
              >
                {_value}
              </option>
            ))}
          </select>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label htmlFor="activity_type">نوع فعالیت</label>
          <select
            className="form-control"
            name="activity_type"
            onChange={(e) =>
              setActivity_type(e.target.value ? Number(e.target.value) : null)
            }
          >
            <option selected value="" disabled hidden>
              لطفا نوع فعالیت را انتخاب کنید
            </option>
            {activityTypeItems?.map((_value, index) => (
              <option
                key={index + 1}
                selected={index + 1 === activity_type}
                value={index + 1}
              >
                {_value}
              </option>
            ))}
          </select>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label>همکاری با فولاد</label>
          <div className="d-flex  align-items-center">
            <label htmlFor="working_by_foolad" className="mr-2">
              توجیح شده
            </label>
            <label className="switch">
              <input
                type="checkbox"
                checked={working_by_foolad}
                id="working_by_foolad"
                onClick={(e) => setWorking_by_foolad(e.target.checked)}
              />
              <span className="slider round"></span>
            </label>
            <label htmlFor="working_by_foolad" className="ml-2">
              توجیه نشده
            </label>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label>وضعیت پرسنل</label>
          <div className="d-flex  align-items-center">
            <label htmlFor="is_active" className="mr-2">
              فعال
            </label>
            <label className="switch">
              <input
                type="checkbox"
                checked={is_active}
                id="is_active"
                onClick={(e) => setIs_active(e.target.checked)}
              />
              <span className="slider round"></span>
            </label>
            <label htmlFor="is_active" className="ml-2">
              غیر فعال
            </label>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-2">
          <label>نوع پرسنل</label>
          <div className="d-flex  align-items-center">
            <label htmlFor="is_active" className="mr-2">
              ویژه
            </label>
            <label className="switch">
              <input
                type="checkbox"
                checked={is_special}
                id="is_special"
                onClick={(e) => setIs_special(e.target.checked)}
              />
              <span className="slider round"></span>
            </label>
            <label htmlFor="is_special" className="ml-2">
              عادی
            </label>
          </div>
        </div>
        <div className="col-12 col-md mb-2">
          <label htmlFor="vacation">شروع مرخصی</label>
          <CustomDateTimePicker
            placeholder="تاریخ شروع مرخصی را انتخاب کنید"
            onChange={(e) => setVacation((prev) => ({ ...prev, from: e }))}
            initValue={isEmpty(vacation.from) ? null : vacation.from}
          />
        </div>
        <div className="col-12 col-md mb-2">
          <label htmlFor="vacation">پایان مرخصی</label>
          <CustomDateTimePicker
            placeholder="پایان مرخصی را انتخاب کنید"
            onChange={(e) => setVacation((prev) => ({ ...prev, to: e }))}
            initValue={isEmpty(vacation.to) ? null : vacation.to}
          />
        </div>
        <div className="col-12 mb-2">
          <label htmlFor="phone_numbers">شماره تماس ها</label>
          <input
            type="text"
            id="phone_numbers"
            name="phone_numbers"
            className="form-control"
            value={phone_numbers}
            onChange={(e) => setPhone_numbers(e.target.value)}
          />
        </div>
        <div className="col-12 mb-2">
          <label htmlFor="business_address">آدرس محل کار</label>
          <textarea
            id="business_address"
            name="business_address"
            className="form-control"
            value={business_address}
            rows={1}
            onChange={(e) => setBusiness_address(e.target.value)}
          />
        </div>
        <div className="col-12 mb-2">
          <label htmlFor="about_me">درباره پرسنل</label>
          <textarea
            id="about_me"
            name="about_me"
            className="form-control"
            value={about_me}
            rows={3}
            onChange={(e) => setAbout_me(e.target.value)}
          />
        </div>
        <div className="col-12 mb-2">
          <label htmlFor="description">توضیحات</label>
          <textarea
            id="description"
            name="description"
            className="form-control"
            value={description}
            rows={3}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
      </div>

      <button
        className={`btn btn-${id ? "primary" : "success"} btn-block`}
        type="submit"
      >
        <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
      </button>
    </form>
  );

  return (
    <>
      <SiteTitle title="پرسنل" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "پرسنل", type: "a" },
        ]}
        title="پرسنل ها"
      />

      <CardLayout>
        <div className="mb-2">
          {permission.personnel_create && (
            <button
              className="btn btn-success"
              onClick={() => {
                handleShowModal();
                setUsername(Math.floor(Math.random() * 1e7));
              }}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          )}
          <button
            onClick={() => setIsShowAdvancedSearch(!isShowAdvancedSearch)}
            className={`btn btn-${
              isShowAdvancedSearch ? "" : "outline-"
            }primary ml-2`}
          >
            جستجو پیشرفته
          </button>
        </div>
        <div>
          <form className="input-group mb-3" onSubmit={handleGetPersonnels}>
            <div className="input-group-prepend">
              <TooltipTitle title="نوع" placement="bottom">
                {personnelTypeButton(isSpecial, setIsSpecial)}
              </TooltipTitle>
            </div>
            <div className="input-group-prepend col-6 col-sm-4 col-md-3 col-lg-2 px-0">
              <AsyncSelect
                openMenuOnFocus
                cacheOptions
                placeholder="تخصص را انتخاب نمایید"
                isLoading={isLoader}
                noOptionsMessage={() => <p>تخصصی برای نمایش یافت نشد</p>}
                loadingMessage={() => <p>لطفا منتظر بمانید ...</p>}
                loadOptions={(val, callback) => {
                  handleSearchServices(val, callback);
                }}
                defaultOptions
                className="w-100"
                classNamePrefix="react-select"
                onChange={(e) => setType(e.value)}
              />
            </div>
            <input
              type="text"
              name="search"
              autoComplete="off"
              placeholder="جستجو ..."
              className="form-control"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <div className="input-group-append">
              <button type="submit" className="btn btn-primary">
                جستجو
              </button>
            </div>
          </form>
          {isShowAdvancedSearch && (
            <Animations name="fadeIn">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3 mb-2">
                  <TooltipTitle title="از تاریخ ثبت نام">
                    <DateInput
                      id="from_date"
                      value={from_registry_date}
                      className="form-control"
                      name="from_registry_date"
                      onChange={(e) => setFrom_registry_date(e.target.value)}
                      autoOk="false"
                      placeholder="از تاریخ ثبت نام"
                      dialogContainerStyle={dialogContainerStyle}
                    />
                  </TooltipTitle>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-2">
                  <TooltipTitle title="تا تاریخ ثبت نام">
                    <DateInput
                      id="to_date"
                      value={to_registry_date}
                      className="form-control"
                      name="to_registry_date"
                      onChange={(e) => setTo_registry_date(e.target.value)}
                      autoOk="false"
                      placeholder="تا تاریخ ثبت نام"
                      dialogContainerStyle={dialogContainerStyle}
                    />
                  </TooltipTitle>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-2">
                  <TooltipTitle title="از تاریخ خروج">
                    <DateInput
                      id="from_date"
                      value={from_quit_date}
                      className="form-control"
                      name="from_quit_date"
                      onChange={(e) => setFrom_quit_date(e.target.value)}
                      autoOk="false"
                      placeholder="از تاریخ خروج"
                      dialogContainerStyle={dialogContainerStyle}
                    />
                  </TooltipTitle>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-2">
                  <TooltipTitle title="تا تاریخ خروج">
                    <DateInput
                      id="to_date"
                      value={to_quit_date}
                      className="form-control"
                      name="to_quit_date"
                      onChange={(e) => setTo_quit_date(e.target.value)}
                      autoOk="false"
                      placeholder="تا تاریخ خروج"
                      dialogContainerStyle={dialogContainerStyle}
                    />
                  </TooltipTitle>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-2">
                  <TooltipTitle title="نوع متخصص">
                    <select
                      className="form-control"
                      name="expert_type"
                      onChange={(e) =>
                        setExpert_type(
                          e.target.value ? Number(e.target.value) : null
                        )
                      }
                    >
                      <option value="">نوع متخصص: همه</option>
                      {expertTypeItems?.map((_value, index) => (
                        <option
                          key={index + 1}
                          selected={index + 1 === expert_type}
                          value={index + 1}
                        >
                          {_value}
                        </option>
                      ))}
                    </select>
                  </TooltipTitle>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-2">
                  <TooltipTitle title="نوع فعالیت">
                    <select
                      className="form-control"
                      name="activity_type"
                      onChange={(e) =>
                        setActivity_type(
                          e.target.value ? Number(e.target.value) : null
                        )
                      }
                    >
                      <option value="">نوع فعالیت: همه</option>
                      {activityTypeItems?.map((_value, index) => (
                        <option
                          key={index + 1}
                          selected={index + 1 === activity_type}
                          value={index + 1}
                        >
                          {_value}
                        </option>
                      ))}
                    </select>
                  </TooltipTitle>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-2">
                  <TooltipTitle title="وضعیت">
                    <select
                      className="form-control"
                      name="isActive"
                      onChange={(e) => setIsActive(e.target.value)}
                    >
                      <option value="">وضعیت: همه</option>
                      <option selected={"true" === isActive} value="true">
                        فعال
                      </option>
                      <option selected={"false" === isActive} value="false">
                        غیرفعال
                      </option>
                    </select>
                  </TooltipTitle>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-2">
                  <TooltipTitle title="اعتبار حساب">
                    <select
                      className="form-control"
                      name="activity_type"
                      onChange={(e) => setBalanceFilter(e.target.value)}
                    >
                      <option value="">اعتبار حساب: همه</option>
                      <option
                        selected={"liability" === balanceFilter}
                        value="liability"
                      >
                        بدهکار
                      </option>
                      <option
                        selected={"credits" === balanceFilter}
                        value="credits"
                      >
                        طلبکار
                      </option>
                    </select>
                  </TooltipTitle>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-2">
                  <TooltipTitle title="مرتب سازی بر اساس">
                    <select
                      className="form-control"
                      value={sort_by}
                      onChange={(e) => setSort_by(e.target.value)}
                    >
                      {sortByOptions.map((_item, index) => (
                        <optgroup label={_item.label} key={index}>
                          {_item.options?.map((option) => (
                            <option
                              key={option.value}
                              selected={sort_by === option.value}
                              value={option.value}
                            >
                              {option.title}
                            </option>
                          ))}
                        </optgroup>
                      ))}
                    </select>
                  </TooltipTitle>
                </div>
              </div>
            </Animations>
          )}
        </div>
        {isEmpty(personnels) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center mt-2">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div className="mb-2">
                تعداد کل :{" "}
                <span className="badge badge-primary font-weight-bold">
                  {totalCount}
                </span>
              </div>
              <div>
                <select
                  className="form-control mb-2"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                  <option value={200} selected={200 === limit}>
                    200
                  </option>
                  <option value={400} selected={400 === limit}>
                    400
                  </option>
                  <option value={700} selected={700 === limit}>
                    700
                  </option>
                  <option value={1000} selected={1000 === limit}>
                    1000
                  </option>
                </select>
              </div>
            </div>
            <Table
              responsive
              hover
              borderless
              striped
              className="scrollable-table"
            >
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>شناسه</th>
                  <th>نام</th>
                  <th>نام خانوادگی</th>
                  <th>شماره موبایل</th>
                  <th>کد پرسنلی</th>
                  <th>نوع پرسنل</th>
                  <th>نوع</th>
                  <th>نوع متخصص</th>
                  <th>
                    بدهکاری کل <Currency />
                  </th>
                  <th>تعداد تخلفات</th>
                  <th>تعداد درخواست</th>
                  <th>رتبه</th>
                  <th>تعداد امتیاز</th>
                  <th className="text-center">
                    تعداد کل :{" "}
                    <span className="badge badge-primary font-weight-bold p-1">
                      {totalCount}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {personnels.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{_item.pk}</td>
                    <td>{_item.first_name}</td>
                    <td>{_item.last_name}</td>
                    <td>{_item.mobile}</td>
                    <td>{_item.username}</td>
                    <td>{_item.type}</td>
                    <td>
                      {_item.is_special ? (
                        <span className="badge badge-primary font-weight-bold">
                          ویژه
                        </span>
                      ) : (
                        <span className="badge badge-secondary font-weight-bold">
                          عادی
                        </span>
                      )}
                    </td>
                    <td>
                      {_item?.expert_type ? (
                        <span>{expertTypeItems[_item?.expert_type - 1]}</span>
                      ) : (
                        "تعریف نشده"
                      )}
                    </td>
                    <td>
                      <ConvertCurrency price={_item?.balance} />{" "}
                    </td>
                    <td>{numberSeparate(_item.count_violation)}</td>
                    <td>{numberSeparate(_item.count_failurerequest)}</td>
                    <td>{_item?.ratings?.toFixed(2)}</td>
                    <td>{numberSeparate(_item.ratings_count)}</td>
                    <td className="mw-25">
                      {permission.personnel_get && (
                        <button
                          onClick={() =>
                            handleGetPersonnel(_item.pk, handleShowDetailsModal)
                          }
                          className="btn btn-info mr-2"
                        >
                          جزئیات
                        </button>
                      )}
                      {permission.personnel_get && (
                        <button
                          onClick={() =>
                            handleGetPersonnel(_item.pk, () =>
                              handleShowExpertiseModal(_item.pk)
                            )
                          }
                          className="btn btn-warning mr-2"
                        >
                          تخصص
                        </button>
                      )}
                      {(permission.personnel_get ||
                        permission.personnel_update) && (
                        <button
                          onClick={() =>
                            handleGetPersonnel(_item.pk, handleShowModal)
                          }
                          className="btn btn-primary mr-2"
                        >
                          جزئیات و ویرایش
                        </button>
                      )}
                      {permission.personnel_destroy && (
                        <i
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeletePersonnel(_item.pk),
                              `آیا از حذف ${_item.first_name} ${_item.last_name} اطمینان دارید؟`
                            )
                          }
                          className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} پرسنل`}
        show={isShowModal}
        onHide={handleCloseModal}
        size="xl"
      >
        {id ? (
          <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
            <Tab className="card card-body" eventKey="0" title="اطلاعات پرسنل">
              {personnelForm()}
            </Tab>

            {permission.personnel_get && (
              <Tab className="card card-body" eventKey="1" title="آمار پرسنل">
                <div className="row">
                  <ItemInfo label="تاریخ پیوستن">
                    <p>{convertDate(personnel?.date_joined)}</p>
                  </ItemInfo>
                  {personnel?.registry_time && (
                    <ItemInfo label="تاریخ ثبت نام">
                      <p>{convertDate(personnel?.registry_time)}</p>
                    </ItemInfo>
                  )}
                  {personnel?.quit_time && (
                    <ItemInfo label="تاریخ خروج">
                      <p>{convertDate(personnel?.quit_time)}</p>
                    </ItemInfo>
                  )}
                  <ItemInfo label="تعداد تخلفات">
                    <p>{personnel?.violation}</p>
                  </ItemInfo>
                  <ItemInfo label="تعداد درخواست">
                    <p>{personnel?.failurerequest}</p>
                  </ItemInfo>
                  <ItemInfo label="فاکتور فولاد">
                    <p>{personnel?.order_with_invoices}</p>
                  </ItemInfo>
                  <ItemInfo label="سفارشات بدون فاکتور">
                    <p>{personnel?.order_without_invoices}</p>
                  </ItemInfo>
                  <ItemInfo label="بازخورد گرفته نشده ">
                    <p>{personnel?.without_feedbacks}</p>
                  </ItemInfo>
                  <ItemInfo label="تعداد نارضایتی ">
                    <p>{personnel?.weak_feedbacks}</p>
                  </ItemInfo>
                  <ItemInfo label="درصد اعلام خرابی به تعداد کل سفارش">
                    <p>
                      {convertPercentNumber(personnel?.failurerequest_percent)}%
                    </p>
                  </ItemInfo>
                  <ItemInfo label="درصد ثبت تخلف به تعداد کل سفارش ">
                    <p>{convertPercentNumber(personnel?.violation_percent)}%</p>
                  </ItemInfo>
                  <ItemInfo label="درصد نارضایتی به تعداد کل سفارش">
                    <p>
                      {convertPercentNumber(personnel?.weak_feedbacks_percent)}%
                    </p>
                  </ItemInfo>
                  <ItemInfo label="رتبه">
                    <p>{personnel?.ratings}</p>
                  </ItemInfo>
                  <ItemInfo label="کل کارهای پرسنل">
                    <p>{personnel?.total_orders || personnel?._jobs}</p>
                  </ItemInfo>
                  <ItemInfo label="کارهای موفق">
                    <p>
                      {personnel?.success_orders_count ||
                        personnel?.success_orders}
                    </p>
                  </ItemInfo>
                  <ItemInfo label="درصد کارهای موفق">
                    <p>
                      {convertPercentNumber(personnel?.success_orders_percent)}%
                    </p>
                  </ItemInfo>
                  <ItemInfo label="کارهای کنسل شده">
                    <p>
                      {personnel?.cancel_orders_count ||
                        personnel?.cancel_orders}
                    </p>
                  </ItemInfo>
                  <ItemInfo label="درصد کارهای کنسل شده">
                    <p>
                      {convertPercentNumber(personnel?.cancel_orders_percent)}%
                    </p>
                  </ItemInfo>
                  {!isEmpty(personnel?.expertise) && (
                    <ItemInfo label="تخصص ها" grid="col-12">
                      <p className="text-justify">
                        {personnel?.expertise?.map((expertis) => (
                          <span>{expertis?.name} - </span>
                        ))}
                      </p>
                    </ItemInfo>
                  )}
                </div>
                {permission.personnel_update && (
                  <>
                    <hr />
                    <Comments />
                  </>
                )}
              </Tab>
            )}

            <Tab className="card card-body" eventKey="2" title="تخلفات">
              <div className="mb-2">
                <button
                  onClick={() => setIsShowAdvancedSearch(!isShowAdvancedSearch)}
                  className={`btn btn-${
                    isShowAdvancedSearch ? "" : "outline-"
                  }primary mr-2`}
                >
                  جستجو پیشرفته
                </button>
              </div>
              <form className="input-group mb-3" onSubmit={handleGetViolations}>
                <input
                  type="text"
                  name="search"
                  autoComplete="off"
                  placeholder="جستجو ..."
                  className="form-control"
                />
                <div className="input-group-append">
                  <button type="submit" className="btn btn-primary">
                    جستجو
                  </button>
                </div>
              </form>

              {isShowAdvancedSearch && (
                <Animations name="fadeIn">
                  <div className="row">
                    <div className="col-12 mb-2">
                      <div className="btn-group">
                        {[3, 7, 30, 60, 90, 120, 180, 365].map((item) => (
                          <button
                            className="btn btn-outline-primary"
                            onClick={() => handleDateRange(item)}
                          >
                            {item} روز اخیر
                          </button>
                        ))}
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 mb-2">
                      <TooltipTitle title="وضعیت">
                        <select
                          className="form-control mb-3"
                          onChange={(e) => setStatus(e.target.value)}
                        >
                          <option value="" selected={"" === status}>
                            وضعیت: همه
                          </option>
                          <option value="True" selected={"True" === status}>
                            خاتمه یافته
                          </option>
                          <option value="False" selected={"False" === status}>
                            خاتمه نیافته
                          </option>
                        </select>
                      </TooltipTitle>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 mb-2">
                      <TooltipTitle title="از تاریخ">
                        <DateInput
                          id="from_date"
                          value={from_date}
                          className="form-control"
                          name="from_date"
                          onChange={(e) => setFrom_date(e.target.value)}
                          autoOk="false"
                          placeholder="از تاریخ"
                          dialogContainerStyle={dialogContainerStyle}
                        />
                      </TooltipTitle>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 mb-2">
                      <TooltipTitle title="تا تاریخ">
                        <DateInput
                          id="to_date"
                          value={to_date}
                          className="form-control"
                          name="to_date"
                          onChange={(e) => setTo_date(e.target.value)}
                          autoOk="false"
                          placeholder="تا تاریخ"
                          dialogContainerStyle={dialogContainerStyle}
                        />
                      </TooltipTitle>
                    </div>
                  </div>
                </Animations>
              )}
              <hr className="my-2" />
              {isEmpty(violations) ? (
                <EmptyData />
              ) : (
                <>
                  <div className="d-flex justify-content-between align-items-center">
                    <PaginationList
                      setPageNumber={setDetailsPageNumber}
                      pageCount={detailsTotalCount / detailsLimit}
                    />
                    <div>
                      <select
                        className="form-control mb-3"
                        onChange={(e) =>
                          setDetailsLimit(Number(e.target.value))
                        }
                      >
                        <option value={10} selected={10 === detailsLimit}>
                          10
                        </option>
                        <option value={25} selected={25 === detailsLimit}>
                          25
                        </option>
                        <option value={50} selected={50 === detailsLimit}>
                          50
                        </option>
                        <option value={75} selected={75 === detailsLimit}>
                          75
                        </option>
                        <option value={100} selected={100 === detailsLimit}>
                          100
                        </option>
                      </select>
                    </div>
                  </div>
                  <Table
                    responsive
                    hover
                    borderless
                    striped
                    className="scrollable-table"
                  >
                    <thead className="thead-dark text-center">
                      <tr>
                        <th>#</th>
                        <th>مشتری</th>
                        <th>تاریخ درخواست</th>
                        <th>تاریخ اعمال جریمه و رسیدگی </th>
                        <th>ثبت تا درخواست</th>
                        <th>ثبت تا رسیدگی</th>
                        <th>کد پیگیری سفارش</th>
                        <th>نوع خدمات</th>
                        <th>پرسنل</th>
                        <th>نوع تخلف</th>
                        <th>توضیحات</th>
                        <th>نظر رسیدگی کننده</th>
                        <th>نتیجه نهایی</th>
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {violations?.map((_item, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>
                            <TooltipTitle
                              title={_item?.order?.client?.mobile}
                              placement="bottom"
                            >
                              <span>
                                {_item?.order?.client?.first_name}{" "}
                                {_item?.order?.client?.last_name}
                              </span>
                            </TooltipTitle>
                          </td>
                          <td>{convertDate(_item?.created)}</td>
                          <td>{convertDate(_item?.end_date)}</td>
                          <td>{numberSeparate(_item?.until_created)} روز</td>
                          <td>{numberSeparate(_item?.until_solved)}</td>
                          <td>{_item?.order?.ref_num}</td>
                          <td>{_item?.order?.service}</td>
                          <td>
                            {!isEmpty(_item?.order?.personnel) &&
                              _item?.order?.personnel?.map(
                                (_personnelVal, index) => (
                                  <span
                                    className={`d-block ${
                                      index + 1 !==
                                      _item?.order?.personnel?.length
                                        ? "border-bottom"
                                        : ""
                                    }`}
                                  >
                                    <TooltipTitle
                                      title={_personnelVal?.mobile ?? "ندارد"}
                                      placement="bottom"
                                    >
                                      <span className="mx-1">
                                        {_personnelVal?.first_name}{" "}
                                        {_personnelVal?.last_name}
                                      </span>
                                    </TooltipTitle>
                                  </span>
                                )
                              )}
                          </td>
                          <td>{_item?.type?.description}</td>
                          <td>{_item?.description || "-"}</td>
                          <td>{_item?.solved?.description || "-"}</td>
                          <td>{_item?.result?.description || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </Tab>
            <Tab className="card card-body" eventKey="3" title="درخواست ها">
              <div className="mb-2">
                <button
                  onClick={() => setIsShowAdvancedSearch(!isShowAdvancedSearch)}
                  className={`btn btn-${
                    isShowAdvancedSearch ? "" : "outline-"
                  }primary mr-2`}
                >
                  جستجو پیشرفته
                </button>
              </div>
              <form
                className="input-group mb-3"
                onSubmit={handleGetFailureRequests}
              >
                <input
                  type="text"
                  name="search"
                  autoComplete="off"
                  placeholder="جستجو ..."
                  className="form-control"
                />
                <div className="input-group-append">
                  <button type="submit" className="btn btn-primary">
                    جستجو
                  </button>
                </div>
              </form>

              {isShowAdvancedSearch && (
                <Animations name="fadeIn">
                  <div className="row">
                    <div className="col-12 mb-2">
                      <div className="btn-group">
                        {[3, 7, 30, 60, 90, 120, 180, 365].map((item) => (
                          <button
                            className="btn btn-outline-primary"
                            onClick={() => handleDateRange(item)}
                          >
                            {item} روز اخیر
                          </button>
                        ))}
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 mb-2">
                      <TooltipTitle title="وضعیت">
                        <select
                          className="form-control mb-3"
                          onChange={(e) => setStatus(e.target.value)}
                        >
                          <option value="" selected={"" === status}>
                            وضعیت: همه
                          </option>
                          <option value="True" selected={"True" === status}>
                            خاتمه یافته
                          </option>
                          <option value="False" selected={"False" === status}>
                            خاتمه نیافته
                          </option>
                        </select>
                      </TooltipTitle>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 mb-2">
                      <TooltipTitle title="از تاریخ">
                        <DateInput
                          id="from_date"
                          value={from_date}
                          className="form-control"
                          name="from_date"
                          onChange={(e) => setFrom_date(e.target.value)}
                          autoOk="false"
                          placeholder="از تاریخ"
                          dialogContainerStyle={dialogContainerStyle}
                        />
                      </TooltipTitle>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 mb-2">
                      <TooltipTitle title="تا تاریخ">
                        <DateInput
                          id="to_date"
                          value={to_date}
                          className="form-control"
                          name="to_date"
                          onChange={(e) => setTo_date(e.target.value)}
                          autoOk="false"
                          placeholder="تا تاریخ"
                          dialogContainerStyle={dialogContainerStyle}
                        />
                      </TooltipTitle>
                    </div>
                  </div>
                </Animations>
              )}
              <hr className="my-2" />
              {isEmpty(failureRequests) ? (
                <EmptyData />
              ) : (
                <>
                  <div className="d-flex justify-content-between align-items-center">
                    <PaginationList
                      setPageNumber={setDetailsPageNumber}
                      pageCount={detailsTotalCount / detailsLimit}
                    />
                    <div>
                      <select
                        className="form-control mb-3"
                        onChange={(e) =>
                          setDetailsLimit(Number(e.target.value))
                        }
                      >
                        <option value={10} selected={10 === detailsLimit}>
                          10
                        </option>
                        <option value={25} selected={25 === detailsLimit}>
                          25
                        </option>
                        <option value={50} selected={50 === detailsLimit}>
                          50
                        </option>
                        <option value={75} selected={75 === detailsLimit}>
                          75
                        </option>
                        <option value={100} selected={100 === detailsLimit}>
                          100
                        </option>
                      </select>
                    </div>
                  </div>
                  <Table
                    responsive
                    hover
                    borderless
                    striped
                    className="scrollable-table"
                  >
                    <thead className="thead-dark text-center">
                      <tr>
                        <th>#</th>
                        <th>مشتری</th>
                        <th>تاریخ درخواست</th>
                        <th>تاریخ ثبت سفارش</th>
                        <th>تاریخ نهایی</th>
                        <th>ثبت تا درخواست</th>
                        <th>چند روزه حل شد</th>
                        <th>نوع درخواست</th>
                        <th>کد پیگیری سفارش</th>
                        <th>شماره تماس کاربر</th>
                        <th>پرسنل</th>
                        <th>نتیجه نهایی</th>
                        <th>چطوری راضیش کردم؟</th>
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {failureRequests?.map((_item, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>
                            <TooltipTitle
                              title={_item?.order?.client?.mobile}
                              placement="bottom"
                            >
                              <span>
                                {_item?.order?.client?.first_name}{" "}
                                {_item?.order?.client?.last_name}
                              </span>
                            </TooltipTitle>
                          </td>
                          <td>{convertDate(_item?.created)}</td>
                          <td>{convertDate(_item?.order?.created)}</td>
                          <td>{_item?.end_date}</td>
                          <td>{numberSeparate(_item?.until_created)} روز</td>
                          <td>{numberSeparate(_item?.until_solved)}</td>
                          <td>{_item?.request_type?.description}</td>
                          <td>{_item?.order?.ref_num}</td>
                          <td>{_item?.order?.client?.mobile}</td>
                          <td>
                            {!isEmpty(_item?.order?.personnel) &&
                              _item?.order?.personnel?.map(
                                (_personnelVal, index) => (
                                  <span
                                    className={`d-block ${
                                      index + 1 !==
                                      _item?.order?.personnel?.length
                                        ? "border-bottom"
                                        : ""
                                    }`}
                                  >
                                    <TooltipTitle
                                      title={_personnelVal?.mobile ?? "ندارد"}
                                      placement="bottom"
                                    >
                                      <span className="mx-1">
                                        {_personnelVal?.first_name}{" "}
                                        {_personnelVal?.last_name}
                                      </span>
                                    </TooltipTitle>
                                  </span>
                                )
                              )}
                          </td>
                          <td>{_item?.result}</td>
                          <td>
                            {_item?.customer_satisfaction_item?.description}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </Tab>
            {permission.invoices_list && (
              <Tab className="card card-body" eventKey="4" title="فاکتورها">
                <form className="input-group mb-3" onSubmit={handleGetInvoices}>
                  <input
                    type="text"
                    name="search"
                    autoComplete="off"
                    placeholder="جستجو ..."
                    className="form-control"
                  />
                  <div className="input-group-append">
                    <button type="submit" className="btn btn-primary">
                      جستجو
                    </button>
                  </div>
                </form>
                {isEmpty(invoices) ? (
                  <EmptyData />
                ) : (
                  <>
                    <div className="d-flex justify-content-between align-items-center">
                      <PaginationList
                        setPageNumber={setDetailsPageNumber}
                        pageCount={detailsTotalCount / detailsLimit}
                      />
                      <div>
                        <select
                          className="form-control mb-3"
                          onChange={(e) =>
                            setDetailsLimit(Number(e.target.value))
                          }
                        >
                          <option value={10} selected={10 === detailsLimit}>
                            10
                          </option>
                          <option value={25} selected={25 === detailsLimit}>
                            25
                          </option>
                          <option value={50} selected={50 === detailsLimit}>
                            50
                          </option>
                          <option value={75} selected={75 === detailsLimit}>
                            75
                          </option>
                          <option value={100} selected={100 === detailsLimit}>
                            100
                          </option>
                        </select>
                      </div>
                    </div>
                    <Table
                      responsive
                      hover
                      borderless
                      striped
                      className="scrollable-table"
                    >
                      <thead className="thead-dark text-center">
                        <tr>
                          <th>#</th>
                          <th>نام و نام خانوادگی</th>
                          <th>نام کاربری</th>
                          <th>شماره موبایل</th>
                          <th>نوع خدمت</th>
                          <th>کد پیگیری سفارش</th>
                          <th>تاریخ ایجاد سفارش</th>
                          <th>مبلغ (ريال)</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {invoices.map((_item, index) => (
                          <tr>
                            <td>{index + 1}</td>
                            <td>
                              {_item?.order?.client?.first_name}{" "}
                              {_item?.order?.client?.last_name}
                            </td>
                            <td>{_item?.order?.client?.username}</td>
                            <td>{_item?.order?.client?.mobile}</td>
                            <td>{_item?.order?.service}</td>
                            <td>{_item?.order?.ref_num}</td>
                            <td>{convertDate(_item?.order?.created)}</td>
                            <td>
                              <span className="font-weight-bold">
                                <ConvertCurrency price={_item?.total} />
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </>
                )}
              </Tab>
            )}
            {permission.payment_transactions_list && (
              <Tab className="card card-body" eventKey="5" title="سوابق پرداخت">
                <form
                  className="input-group mb-3"
                  onSubmit={handleGetPaymentTransactions}
                >
                  <input
                    type="text"
                    name="search"
                    autoComplete="off"
                    placeholder="جستجو ..."
                    className="form-control"
                  />
                  <div className="input-group-append">
                    <button type="submit" className="btn btn-primary">
                      جستجو
                    </button>
                  </div>
                </form>
                {isEmpty(paymentTransactions) ? (
                  <EmptyData />
                ) : (
                  <>
                    <div className="d-flex justify-content-between align-items-center">
                      <PaginationList
                        setPageNumber={setDetailsPageNumber}
                        pageCount={detailsTotalCount / detailsLimit}
                      />
                      <div>
                        <select
                          className="form-control mb-3"
                          onChange={(e) =>
                            setDetailsLimit(Number(e.target.value))
                          }
                        >
                          <option value={10} selected={10 === detailsLimit}>
                            10
                          </option>
                          <option value={25} selected={25 === detailsLimit}>
                            25
                          </option>
                          <option value={50} selected={50 === detailsLimit}>
                            50
                          </option>
                          <option value={75} selected={75 === detailsLimit}>
                            75
                          </option>
                          <option value={100} selected={100 === detailsLimit}>
                            100
                          </option>
                        </select>
                      </div>
                    </div>
                    <Table
                      responsive
                      hover
                      borderless
                      striped
                      className="scrollable-table"
                    >
                      <thead className="thead-dark text-center">
                        <tr>
                          <th>#</th>
                          <th>نام و نام خانوادگی</th>
                          <th>نام کاربری</th>
                          <th>شماره موبایل</th>
                          <th>تاریخ ایجاد</th>
                          <th>مبلغ (ريال)</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {paymentTransactions.map((_item, index) => (
                          <tr>
                            <td>{index + 1}</td>
                            <td>
                              {_item?.client?.first_name}{" "}
                              {_item?.client?.last_name}
                            </td>
                            <td>{_item?.client?.username}</td>
                            <td>{_item?.client?.mobile}</td>
                            <td>{_item?.created_time}</td>
                            <td>
                              <ConvertCurrency price={_item?.amount} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </>
                )}
              </Tab>
            )}
            <Tab className="card card-body" eventKey="6" title="مدارک">
              <label
                htmlFor="document"
                type="button"
                className="btn btn-success"
              >
                <i className="fa fa-plus mr-2" />
                بارگذاری فایل
                <input
                  type="file"
                  multiple
                  accept=".jpg,.jpeg,.png,.gif,.docx,.xlsx,.csv,.pdf,.mp4,.avi;capture=camera"
                  id="document"
                  name="document"
                  className="d-none"
                  onChange={(e) => {
                    handleUploadDocument(e.target.files);
                    document.getElementById(`document`).value = "";
                  }}
                />
              </label>
              <hr />
              {isEmpty(personnel.documents) ? (
                <EmptyData />
              ) : (
                <div className="row">
                  {personnel?.documents?.map((_item) => (
                    <div key={_item.id} className="col-auto">
                      <div className="btn btn-group">
                        <button
                          type="button"
                          className="btn btn-primary btn-block"
                          onClick={() => handleGetDocument(_item.id)}
                        >
                          {_item?.file_name}
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeleteDocument(_item.id),
                              `آیا از حذف فایل ${_item?.file_name} اطمینان دارید؟`
                            )
                          }
                        >
                          حذف
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Tab>
          </Tabs>
        ) : (
          personnelForm()
        )}
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Details Modal */}
      <CustomModal
        title={`جزئیات پرسنل ${personnel?.first_name} ${personnel?.last_name}`}
        show={isShowDetailsModal}
        onHide={handleCloseDetailsModal}
        size="xl"
      >
        <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
          <Tab className="card card-body" eventKey="0" title="اطلاعات پرسنل">
            <div className="row">
              <ItemInfo label="شناسه">
                <p>{personnel?.pk}</p>
              </ItemInfo>
              <ItemInfo label="نوع پرسنل">
                <p>{personnel?.type}</p>
              </ItemInfo>
              <ItemInfo label="شماره پرسنلی">
                <p>{personnel?.username}</p>
              </ItemInfo>
              <ItemInfo label="نام">
                <p>{personnel?.first_name}</p>
              </ItemInfo>
              <ItemInfo label="نام خانوادگی">
                <p>{personnel?.last_name}</p>
              </ItemInfo>
              <ItemInfo label="تاریخ پیوستن">
                <p>{convertDate(personnel?.date_joined)}</p>
              </ItemInfo>
              {personnel?.registry_time && (
                <ItemInfo label="تاریخ ثبت نام">
                  <p>{convertDate(personnel?.registry_time)}</p>
                </ItemInfo>
              )}
              {personnel?.quit_time && (
                <ItemInfo label="تاریخ خروج">
                  <p>{convertDate(personnel?.quit_time)}</p>
                </ItemInfo>
              )}
              <ItemInfo label="شماره موبایل">
                <TooltipTitle
                  placement="bottom"
                  title={
                    personnel?.mobile_verified ? "تایید شده" : "تایید نشده"
                  }
                >
                  <p>{personnel?.mobile}</p>
                </TooltipTitle>
              </ItemInfo>
              <ItemInfo label="نوع">
                <p>
                  {personnel?.is_special ? (
                    <span className="badge badge-primary">ویژه</span>
                  ) : (
                    <span className="badge badge-secondary">عادی</span>
                  )}
                </p>
              </ItemInfo>
              <ItemInfo label="تعداد تخلفات">
                <p>{personnel?.violation_count}</p>
              </ItemInfo>
              <ItemInfo label="تعداد درخواست">
                <p>{personnel?.failurerequest_count}</p>
              </ItemInfo>
              {personnel?.about_me && (
                <ItemInfo label="درباره پرسنلی">
                  <p>{personnel?.about_me}</p>
                </ItemInfo>
              )}
              {personnel?.description && (
                <ItemInfo label="توضیحات">
                  <p>{personnel?.description}</p>
                </ItemInfo>
              )}
              {personnel?.balance !== 0 && (
                <ItemInfo label="بدهکاری کل">
                  <span dir="ltr">{numberSeparate(personnel?.balance)}</span>{" "}
                  ریال
                </ItemInfo>
              )}
              {personnel?.cooperation_percentage !== 0 && (
                <ItemInfo label="درصد همکاری">
                  <p>
                    {convertPercentNumber(personnel?.cooperation_percentage)}%
                  </p>
                </ItemInfo>
              )}
              {personnel?.initial_invest !== 0 && (
                <ItemInfo label="بلوکه">
                  <p>{personnel?.initial_invest}</p>
                </ItemInfo>
              )}
              {personnel?.activity_type && (
                <ItemInfo label="نوع فعالیت">
                  <p>{activityTypeItems[personnel?.activity_type - 1]}</p>
                </ItemInfo>
              )}
              {personnel?.expert_type && (
                <ItemInfo label="نوع متخصص">
                  <p>{expertTypeItems[personnel?.expert_type - 1]}</p>
                </ItemInfo>
              )}
              <ItemInfo label="فاکتور فولاد">
                <p>{personnel?.order_with_invoices}</p>
              </ItemInfo>
              <ItemInfo label="سفارشات بدون فاکتور">
                <p>{personnel?.order_without_invoices}</p>
              </ItemInfo>
              <ItemInfo label="بازخورد گرفته نشده ">
                <p>{personnel?.without_feedbacks}</p>
              </ItemInfo>
              <ItemInfo label="تعداد نارضایتی ">
                <p>{personnel?.weak_feedbacks}</p>
              </ItemInfo>
              <ItemInfo label="درصد اعلام خرابی به تعداد کل سفارش">
                <p>
                  {convertPercentNumber(personnel?.failurerequest_percent)}%
                </p>
              </ItemInfo>
              <ItemInfo label="درصد ثبت تخلف به تعداد کل سفارش ">
                <p>{convertPercentNumber(personnel?.violation_percent)}%</p>
              </ItemInfo>
              <ItemInfo label="درصد نارضایتی به تعداد کل سفارش">
                <p>
                  {convertPercentNumber(personnel?.weak_feedbacks_percent)}%
                </p>
              </ItemInfo>
              <ItemInfo label="همکاری با فولاد">
                <p>
                  {personnel?.working_by_foolad ? (
                    <span className="badge badge-success">توجیه شده</span>
                  ) : (
                    <span className="badge badge-danger">توجیه نشده</span>
                  )}
                </p>
              </ItemInfo>
              <ItemInfo label="وضعیت">
                <p>
                  {personnel?.is_active ? (
                    <span className="badge badge-success">فعال</span>
                  ) : (
                    <span className="badge badge-danger">غیر فعال</span>
                  )}
                </p>
              </ItemInfo>
              {personnel?.start_vacation && (
                <ItemInfo label="تاریخ شروع تعطیلات">
                  <p>{personnel?.start_vacation}</p>
                </ItemInfo>
              )}
              {personnel?.end_vacation && (
                <ItemInfo label="تاریخ پایان تعطیلات">
                  <p>{personnel?.end_vacation}</p>
                </ItemInfo>
              )}
              <ItemInfo label="رتبه">
                <p>{personnel?.ratings}</p>
              </ItemInfo>
              <ItemInfo label="شماره شبا">
                <p>{personnel?.shaba}</p>
              </ItemInfo>
              <ItemInfo label="کل کارهای پرسنل">
                <p>{personnel?.total_orders || personnel?._jobs}</p>
              </ItemInfo>
              <ItemInfo label="کارهای موفق">
                <p>
                  {personnel?.success_orders_count || personnel?.success_orders}
                </p>
              </ItemInfo>
              <ItemInfo label="درصد کارهای موفق">
                <p>
                  {convertPercentNumber(personnel?.success_orders_percent)}%
                </p>
              </ItemInfo>
              <ItemInfo label="کارهای کنسل شده">
                <p>
                  {personnel?.cancel_orders_count || personnel?.cancel_orders}
                </p>
              </ItemInfo>
              <ItemInfo label="درصد کارهای کنسل شده">
                <p>{convertPercentNumber(personnel?.cancel_orders_percent)}%</p>
              </ItemInfo>
              {!isEmpty(personnel?.expertise) && (
                <ItemInfo label="تخصص ها">
                  <p className="text-justify">
                    {personnel?.expertise?.map((expertis) => (
                      <span>{expertis?.name} - </span>
                    ))}
                  </p>
                </ItemInfo>
              )}
            </div>

            <hr />
            <Comments />
          </Tab>

          <Tab className="card card-body" eventKey="1" title="تخلفات">
            <form className="input-group mb-3" onSubmit={handleGetViolations}>
              <input
                type="text"
                name="search"
                autoComplete="off"
                placeholder="جستجو ..."
                className="form-control"
              />
              <div className="input-group-append">
                <button type="submit" className="btn btn-primary">
                  جستجو
                </button>
              </div>
            </form>
            {isEmpty(violations) ? (
              <EmptyData />
            ) : (
              <>
                <div className="d-flex justify-content-between align-items-center">
                  <PaginationList
                    setPageNumber={setDetailsPageNumber}
                    pageCount={detailsTotalCount / detailsLimit}
                  />
                  <div>
                    <select
                      className="form-control mb-3"
                      onChange={(e) => setDetailsLimit(Number(e.target.value))}
                    >
                      <option value={10} selected={10 === detailsLimit}>
                        10
                      </option>
                      <option value={25} selected={25 === detailsLimit}>
                        25
                      </option>
                      <option value={50} selected={50 === detailsLimit}>
                        50
                      </option>
                      <option value={75} selected={75 === detailsLimit}>
                        75
                      </option>
                      <option value={100} selected={100 === detailsLimit}>
                        100
                      </option>
                    </select>
                  </div>
                </div>
                <Table
                  responsive
                  hover
                  borderless
                  striped
                  className="scrollable-table"
                >
                  <thead className="thead-dark text-center">
                    <tr>
                      <th>#</th>
                      <th>مشتری</th>
                      <th>تاریخ درخواست</th>
                      <th>تاریخ اعمال جریمه و رسیدگی </th>
                      <th>ثبت تا درخواست</th>
                      <th>ثبت تا رسیدگی</th>
                      <th>کد پیگیری سفارش</th>
                      <th>نوع خدمات</th>
                      <th>پرسنل</th>
                      <th>نوع تخلف</th>
                      <th>توضیحات</th>
                      <th>نظر رسیدگی کننده</th>
                      <th>نتیجه نهایی</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {violations?.map((_item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>
                          <TooltipTitle
                            title={_item?.order?.client?.mobile}
                            placement="bottom"
                          >
                            <span>
                              {_item?.order?.client?.first_name}{" "}
                              {_item?.order?.client?.last_name}
                            </span>
                          </TooltipTitle>
                        </td>
                        <td>{convertDate(_item?.created)}</td>
                        <td>{convertDate(_item?.end_date)}</td>
                        <td>{numberSeparate(_item?.until_created)} روز</td>
                        <td>{numberSeparate(_item?.until_solved)}</td>
                        <td>{_item?.order?.ref_num}</td>
                        <td>{_item?.order?.service}</td>
                        <td>
                          {!isEmpty(_item?.order?.personnel) &&
                            _item?.order?.personnel?.map(
                              (_personnelVal, index) => (
                                <span
                                  className={`d-block ${
                                    index + 1 !==
                                    _item?.order?.personnel?.length
                                      ? "border-bottom"
                                      : ""
                                  }`}
                                >
                                  <TooltipTitle
                                    title={_personnelVal?.mobile ?? "ندارد"}
                                    placement="bottom"
                                  >
                                    <span className="mx-1">
                                      {_personnelVal?.first_name}{" "}
                                      {_personnelVal?.last_name}
                                    </span>
                                  </TooltipTitle>
                                </span>
                              )
                            )}
                        </td>
                        <td>{_item?.type?.description}</td>
                        <td>{_item?.description || "-"}</td>
                        <td>{_item?.solved?.description || "-"}</td>
                        <td>{_item?.result?.description || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}
          </Tab>
          <Tab className="card card-body" eventKey="2" title="درخواست ها">
            <form
              className="input-group mb-3"
              onSubmit={handleGetFailureRequests}
            >
              <input
                type="text"
                name="search"
                autoComplete="off"
                placeholder="جستجو ..."
                className="form-control"
              />
              <div className="input-group-append">
                <button type="submit" className="btn btn-primary">
                  جستجو
                </button>
              </div>
            </form>
            {isEmpty(failureRequests) ? (
              <EmptyData />
            ) : (
              <>
                <div className="d-flex justify-content-between align-items-center">
                  <PaginationList
                    setPageNumber={setDetailsPageNumber}
                    pageCount={detailsTotalCount / detailsLimit}
                  />
                  <div>
                    <select
                      className="form-control mb-3"
                      onChange={(e) => setDetailsLimit(Number(e.target.value))}
                    >
                      <option value={10} selected={10 === detailsLimit}>
                        10
                      </option>
                      <option value={25} selected={25 === detailsLimit}>
                        25
                      </option>
                      <option value={50} selected={50 === detailsLimit}>
                        50
                      </option>
                      <option value={75} selected={75 === detailsLimit}>
                        75
                      </option>
                      <option value={100} selected={100 === detailsLimit}>
                        100
                      </option>
                    </select>
                  </div>
                </div>
                <Table
                  responsive
                  hover
                  borderless
                  striped
                  className="scrollable-table"
                >
                  <thead className="thead-dark text-center">
                    <tr>
                      <th>#</th>
                      <th>مشتری</th>
                      <th>تاریخ درخواست</th>
                      <th>تاریخ ثبت سفارش</th>
                      <th>تاریخ نهایی</th>
                      <th>ثبت تا درخواست</th>
                      <th>چند روزه حل شد</th>
                      <th>نوع درخواست</th>
                      <th>کد پیگیری سفارش</th>
                      <th>شماره تماس کاربر</th>
                      <th>پرسنل</th>
                      <th>نتیجه نهایی</th>
                      <th>چطوری راضیش کردم؟</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {failureRequests?.map((_item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>
                          <TooltipTitle
                            title={_item?.order?.client?.mobile}
                            placement="bottom"
                          >
                            <span>
                              {_item?.order?.client?.first_name}{" "}
                              {_item?.order?.client?.last_name}
                            </span>
                          </TooltipTitle>
                        </td>
                        <td>{convertDate(_item?.created)}</td>
                        <td>{convertDate(_item?.order?.created)}</td>
                        <td>{_item?.end_date}</td>
                        <td>{numberSeparate(_item?.until_created)} روز</td>
                        <td>{numberSeparate(_item?.until_solved)}</td>
                        <td>{_item?.request_type?.description}</td>
                        <td>{_item?.order?.ref_num}</td>
                        <td>{_item?.order?.client?.mobile}</td>
                        <td>
                          {!isEmpty(_item?.order?.personnel) &&
                            _item?.order?.personnel?.map(
                              (_personnelVal, index) => (
                                <span
                                  className={`d-block ${
                                    index + 1 !==
                                    _item?.order?.personnel?.length
                                      ? "border-bottom"
                                      : ""
                                  }`}
                                >
                                  <TooltipTitle
                                    title={_personnelVal?.mobile ?? "ندارد"}
                                    placement="bottom"
                                  >
                                    <span className="mx-1">
                                      {_personnelVal?.first_name}{" "}
                                      {_personnelVal?.last_name}
                                    </span>
                                  </TooltipTitle>
                                </span>
                              )
                            )}
                        </td>
                        <td>{_item?.result}</td>
                        <td>
                          {_item?.customer_satisfaction_item?.description}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}
          </Tab>
          {permission.invoices_list && (
            <Tab className="card card-body" eventKey="3" title="فاکتورها">
              <form className="input-group mb-3" onSubmit={handleGetInvoices}>
                <input
                  type="text"
                  name="search"
                  autoComplete="off"
                  placeholder="جستجو ..."
                  className="form-control"
                />
                <div className="input-group-append">
                  <button type="submit" className="btn btn-primary">
                    جستجو
                  </button>
                </div>
              </form>
              {isEmpty(invoices) ? (
                <EmptyData />
              ) : (
                <>
                  <div className="d-flex justify-content-between align-items-center">
                    <PaginationList
                      setPageNumber={setDetailsPageNumber}
                      pageCount={detailsTotalCount / detailsLimit}
                    />
                    <div>
                      <select
                        className="form-control mb-3"
                        onChange={(e) =>
                          setDetailsLimit(Number(e.target.value))
                        }
                      >
                        <option value={10} selected={10 === detailsLimit}>
                          10
                        </option>
                        <option value={25} selected={25 === detailsLimit}>
                          25
                        </option>
                        <option value={50} selected={50 === detailsLimit}>
                          50
                        </option>
                        <option value={75} selected={75 === detailsLimit}>
                          75
                        </option>
                        <option value={100} selected={100 === detailsLimit}>
                          100
                        </option>
                      </select>
                    </div>
                  </div>
                  <Table
                    responsive
                    hover
                    borderless
                    striped
                    className="scrollable-table"
                  >
                    <thead className="thead-dark text-center">
                      <tr>
                        <th>#</th>
                        <th>نام و نام خانوادگی</th>
                        <th>نام کاربری</th>
                        <th>شماره موبایل</th>
                        <th>نوع خدمت</th>
                        <th>کد پیگیری سفارش</th>
                        <th>تاریخ ایجاد سفارش</th>
                        <th>مبلغ (ريال)</th>
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {invoices.map((_item, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>
                            {_item?.order?.client?.first_name}{" "}
                            {_item?.order?.client?.last_name}
                          </td>
                          <td>{_item?.order?.client?.username}</td>
                          <td>{_item?.order?.client?.mobile}</td>
                          <td>{_item?.order?.service}</td>
                          <td>{_item?.order?.ref_num}</td>
                          <td>{convertDate(_item?.order?.created)}</td>
                          <td>
                            <span className="font-weight-bold">
                              <ConvertCurrency price={_item?.total} />
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </Tab>
          )}
          {permission.payment_transactions_list && (
            <Tab className="card card-body" eventKey="4" title="سوابق پرداخت">
              <form
                className="input-group mb-3"
                onSubmit={handleGetPaymentTransactions}
              >
                <input
                  type="text"
                  name="search"
                  autoComplete="off"
                  placeholder="جستجو ..."
                  className="form-control"
                />
                <div className="input-group-append">
                  <button type="submit" className="btn btn-primary">
                    جستجو
                  </button>
                </div>
              </form>
              {isEmpty(paymentTransactions) ? (
                <EmptyData />
              ) : (
                <>
                  <div className="d-flex justify-content-between align-items-center">
                    <PaginationList
                      setPageNumber={setDetailsPageNumber}
                      pageCount={detailsTotalCount / detailsLimit}
                    />
                    <div>
                      <select
                        className="form-control mb-3"
                        onChange={(e) =>
                          setDetailsLimit(Number(e.target.value))
                        }
                      >
                        <option value={10} selected={10 === detailsLimit}>
                          10
                        </option>
                        <option value={25} selected={25 === detailsLimit}>
                          25
                        </option>
                        <option value={50} selected={50 === detailsLimit}>
                          50
                        </option>
                        <option value={75} selected={75 === detailsLimit}>
                          75
                        </option>
                        <option value={100} selected={100 === detailsLimit}>
                          100
                        </option>
                      </select>
                    </div>
                  </div>
                  <Table
                    responsive
                    hover
                    borderless
                    striped
                    className="scrollable-table"
                  >
                    <thead className="thead-dark text-center">
                      <tr>
                        <th>#</th>
                        <th>نام و نام خانوادگی</th>
                        <th>نام کاربری</th>
                        <th>شماره موبایل</th>
                        <th>تاریخ ایجاد</th>
                        <th>مبلغ (ريال)</th>
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {paymentTransactions.map((_item, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>
                            {_item?.client?.first_name}{" "}
                            {_item?.client?.last_name}
                          </td>
                          <td>{_item?.client?.username}</td>
                          <td>{_item?.client?.mobile}</td>
                          <td>{_item?.created_time}</td>
                          <td>
                            <ConvertCurrency price={_item?.amount} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </Tab>
          )}
        </Tabs>
      </CustomModal>
      {/* End Details Modal */}

      {/* Start Expertise Modal */}
      <CustomModal
        title={`مدیریت تخصص ${personnel?.first_name} ${personnel?.last_name}`}
        show={isShowExpertiseModal}
        onHide={handleCloseExpertiseModal}
        size="lg"
      >
        {isEmpty(services) ? (
          <div className="row justify-content-center mx-0">
            {categories?.map((_item, index) => (
              <div className="col-auto my-2 px-1" key={index}>
                <span
                  className="cursorPointer"
                  onClick={() => handleGetServices(_item?.id)}
                >
                  <img
                    key={_item?.id}
                    src={`${appConfigs.APP_DOWNLOAD_LINK}static/console/${_item.icon}.png`}
                    alt={_item.name}
                    width="130"
                    height="130"
                  />
                </span>
              </div>
            ))}
          </div>
        ) : (
          <>
            <div className="mb-3">
              <input
                type="text"
                placeholder="جستجو بر اساس نام در تخصص ها"
                value={expertiseSearch}
                onChange={(e) => {
                  !e.target.value.includes(`\\`) &&
                    setExpertiseSearch(e.target.value);
                }}
                className="form-control"
              />
            </div>
            <div className="mb-2 text-left">
              <button
                className="btn btn-light"
                onClick={() => {
                  setServices([]);
                  setExpertiseSearch("");
                }}
              >
                <i className="fa fa-arrow-right" /> بازگشت
              </button>
            </div>

            <div className="row">
              {services
                ?.filter((s) =>
                  s?.name?.toLowerCase().match(expertiseSearch?.toLowerCase())
                )
                ?.map((service) => (
                  <div className="col-6 col-md-4 mb-2" key={service.id}>
                    <button
                      className={`btn btn${
                        isSelectExpertise(service.id) ? "" : "-outline"
                      }-primary btn-block`}
                      onClick={() => handleUpdatePersonnelExpertise(service.id)}
                    >
                      {service.name}
                    </button>
                  </div>
                ))}
            </div>
          </>
        )}
      </CustomModal>
      {/* End Expertise Modal */}
    </>
  );
};

export default PersonnelAdmin;

const Comments = () => {
  const { personnel, handleAddComment } = useContext(personnelAdminContext);

  const [replyTo, setReplyTo] = useState(null);

  const input = (placeholder) => (
    <div className="mt-3">
      {replyTo && (
        <div className="bg-light rounded mb-2 p-2">
          <div className="d-flex justify-content-between align-items-center">
            <span>
              در حال پاسخ به:
              <span className="font-weight-bold text-primary ml-2">
                {replyTo.user?.first_name} {replyTo.user?.last_name}
              </span>
            </span>
            <i
              className="fa fa-times text-danger cursorPointer"
              onClick={() => setReplyTo(null)}
            />
          </div>
          <hr className="my-2" />
          <span>{replyTo.text}</span>
        </div>
      )}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAddComment(e, replyTo?.id);
          setReplyTo(null);
        }}
        className="input-group"
      >
        <input
          name="comment"
          className="form-control"
          placeholder={placeholder}
        />
        <div className="input-group-append">
          <button type="submit" className="btn btn-primary">
            ارسال
          </button>
        </div>
      </form>
    </div>
  );

  const comment = (_item) => (
    <div
      key={_item.id}
      className={`p-2 rounded my-1 ${
        _item.parent ? "bg-light ml-4 border-white" : "bg-white"
      } border`}
    >
      <div className="d-flex justify-content-between align-items-center">
        <span className="font-weight-bold text-dark">
          {_item.user?.first_name} {_item.user?.last_name}
        </span>
        <span className="text-muted">{convertDate(_item.created)}</span>
      </div>
      <hr className="my-1" />
      <div className="d-flex justify-content-between align-items-end">
        <p className="text-dark mb-0">{_item.text}</p>
        <i
          className="fa fa-share text-primary cursorPointer"
          onClick={() => setReplyTo(_item)}
        />
      </div>
      {!isEmpty(_item.replies) && (
        <div className="mt-3">{_item.replies?.map(comment)}</div>
      )}
    </div>
  );

  return (
    <>
      <h5>گفتگو</h5>
      {!isEmpty(personnel.comments) && <>{personnel.comments?.map(comment)}</>}
      {input(`${replyTo ? "پاسخ" : "پیام"} خود را وارد کنید`)}
    </>
  );
};
